/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useTranslate } from "../../translate";
import { Formik, ErrorMessage } from "formik";
import { useDispatch, useSelector } from "react-redux";
import Button from "@ingka/button";
import ValidationErrorMessage from "../ValidationErrorMessage";
import * as Yup from "yup";
import AssemblyGuideProduct from "./AssemblyGuideProduct";

import "@ingka/svg-icon/style.scss";
import "@ingka/button/style.scss";
import "@ingka/forms/style.scss";
import "@ingka/focus/style.scss";
import "@ingka/hyperlink/style.scss";
import "@ingka/svg-icon/style.scss";
import "./AssemblyGuideModalBody.scss";
import {
  fetchAsssemblyGuideByArticleNumber,
  resetTrackedAsssemblyGuide,
} from "../../redux/assemblyGuide/assemblyGuideAction";
import infoIcon from "@ingka/ssr-icon/paths/information-circle";
import allenKey from "@ingka/ssr-icon/paths/allen-key";
import SSRIcon from "@ingka/ssr-icon";

const AssemblyGuideModalBody = () => {
  const dispatch = useDispatch();
  const i18n = useTranslate();
  const { t, isRtl, getCurrentLanguageCode } = i18n;

  const products = useSelector(
    ({ assemblyGuide }) => assemblyGuide?.assemblyGuideByArticleNumber?.guide
  );

  const assemblyGuideFetchingStatus = useSelector(
    ({ assemblyGuide }) =>
      assemblyGuide?.assemblyGuideByArticleNumber?.fetchingStatus?.state
  );

  const guideErrorMsg = useSelector(
    ({ assemblyGuide }) => assemblyGuide?.assemblyGuideByArticleNumber?.error
  );
  const assemblyGuideInitialValue = {
    articleNum: "",
  };

  const assemblyGuideValidationSchema = Yup.object({
    articleNum: Yup.string()
      .required(t("assemblyGuideModalBody.articleNum.required.text"))
      .matches(
        /^(?:\d{3}\.\d{3}\.\d{2}|\d{8})$/,
        t("assemblyGuideModalBody.articleNum.valid.text")
      ),
  });

  const currentLanguageCode = getCurrentLanguageCode();

  const handleAssemblyGuideByarticleNumBtnClick = ({ articleNum }) => {
    dispatch(resetTrackedAsssemblyGuide());
    dispatch(
      fetchAsssemblyGuideByArticleNumber({
        articleNumber: articleNum,
        lang: currentLanguageCode,
      })
    );
  };

  useEffect(() => {
    dispatch(resetTrackedAsssemblyGuide());
  }, []);

  const closeAndReTrack = () => {
    dispatch(resetTrackedAsssemblyGuide());
  };

  const handleFormKeyDown = (keyEvent) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  };

  return (
    <div className="assembly-guide-modal-body" dir={isRtl() ? "rtl" : "ltr"}>
      <div className="header">
        <div className="header-title">
          {t("assemblyGuideModalBody.header.title")}
        </div>
        <div className="header-desc">
          {t("assemblyGuideModalBody.header.desc")}
        </div>
      </div>
      <hr />
      <div className="assembly-guide-section">
        <Formik
          initialValues={assemblyGuideInitialValue}
          validationSchema={assemblyGuideValidationSchema}
        >
          {({
            values,
            setFieldValue,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setStatus,
            status,
            isValid,
            dirty,
            resetForm,
            /* and other goodies */
          }) => (
            <form onKeyDown={handleFormKeyDown}>
              <div className="assembly-guide-text-field-container">
                <div className="form-field">
                  <div className="input-field label-wrapper label-wrapper--text-input mobile-no-field">
                    <label
                      htmlFor="articleNum"
                      title={t(
                        "assemblyGuideModalBody.articleNum.textField.label"
                      )}
                    >
                      {t("assemblyGuideModalBody.articleNum.textField.label")}
                    </label>
                    <div className="input-field__wrapper">
                      <input
                        type="text"
                        aria-describedby="articleNum"
                        aria-required="false"
                        id="articleNum"
                        name="articleNum"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.articleNum}
                        placeholder={t(
                          "assemblyGuideModalBody.articleNum.textField.placeholder"
                        )}
                        autoComplete="off"
                      />
                      <span className="input-field__border"></span>
                    </div>
                  </div>
                  <div className="validation-error-msg-space">
                    <ErrorMessage
                      name="articleNum"
                      component={ValidationErrorMessage}
                    />
                  </div>
                </div>
              </div>
              {guideErrorMsg && (
                <div className="response-error-msg-space">
                  <ValidationErrorMessage>
                    <SSRIcon paths={infoIcon} />
                    {t("assemblyGuideModalBody.articleNum.notFound")}
                  </ValidationErrorMessage>
                </div>
              )}
              <div className="assembly-guide-btn-container">
                <Button
                  className="assembly-guide-btn"
                  type="emphasised"
                  text={t("assemblyGuideModalBody.articleNum.btn.text")}
                  onClick={() => {
                    handleAssemblyGuideByarticleNumBtnClick({
                      articleNum: values.articleNum,
                    });
                  }}
                  disabled={
                    !(dirty && isValid) ||
                    assemblyGuideFetchingStatus === "inProgress"
                  }
                />
              </div>
              {products && products.length ? (
                <div className="assembly-guide-response-container">
                  <hr />
                  <div className="assembly-guide-response-container-header">
                    <SSRIcon paths={allenKey} colour="black" />
                    <h3>{t("assemblyGuideModalBody.response.header")}</h3>
                  </div>
                  <div className="assembly-guide-response-container-products">
                    <AssemblyGuideProduct product={products?.[0]} />
                  </div>
                  <div className="assembly-guide-response-container-re-check">
                    <Button
                      className="assembly-guide-btn"
                      type="emphasised"
                      text={t(
                        "assemblyGuideModalBody.articleNum.closeOrTrack.btn.text"
                      )}
                      onClick={() => {
                        closeAndReTrack();
                        resetForm();
                      }}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AssemblyGuideModalBody;
